import { useLanguageContext } from '../../../../contexts/LanguageContext';

const useLanguageSelectorConnector = () => {
  return {
    languageContext: useLanguageContext(),
  };
};

export default useLanguageSelectorConnector;
